import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../../../services/api.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CastSpettacolo, PrezzoSpettacolo } from '../../../../shared/interface';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-aggiungi-spettacolo-backoffice',
  templateUrl: './aggiungi-spettacolo-backoffice.component.html',
  styleUrl: './aggiungi-spettacolo-backoffice.component.css'
})
export class AggiungiSpettacoloBackofficeComponent implements OnInit {

  constructor(private apiService: ApiService, private router: Router, private datePipe: DatePipe) { }

  formSpettacolo!: FormGroup;

  loading: boolean = false;

  webshop: boolean = false;
  custom: boolean = false;  
  
  prezzi: PrezzoSpettacolo[] = [];  
  casts: CastSpettacolo[] = [];
  immagini?: {img_box: string, img_home: string, img_cover: string};

  minDate: Date | undefined = new Date();

  section: string = 'info';

  ngOnInit(): void {

    this.formSpettacolo = new FormGroup({
      spettacolo: new FormControl(null, Validators.required),
      compagnia: new FormControl(null),
      descrizione: new FormControl(null),
      dal_al: new FormControl(null, Validators.required),
      prenotabile_dal: new FormControl(null),
      prenotabile_dal_orario: new FormControl(null),
      online: new FormControl(null),
      evidenzia: new FormControl(null),
      gratuito: new FormControl(null),
      in_vendita_dal: new FormControl(null),
      in_vendita_dal_data: new FormControl(null),
      soon_in_vendita: new FormControl(null),
      sold_out: new FormControl(null),
      annullato: new FormControl(null),
      webshop: new FormControl(null),
      custom: new FormControl(null),
      link_webshop: new FormControl(null),
      link_custom: new FormControl(null),
      descrizione_prezzi: new FormControl(null)
    })

  }

  onCheckBox(value: any, tipo: string) {
    if (value.length > 0) {
      if (tipo == 'webshop')
        this.webshop = true;
      else
        this.custom = true; 
    } else {
      if (tipo == 'webshop')
        this.webshop = false;
      else
        this.custom = false; 
    }
  }

  onInVenditaDal(value: any) {
    if (value.length > 0) {
      this.formSpettacolo.get('in_vendita_dal_data')?.setValidators(Validators.required);
    } else {
      this.formSpettacolo.get('in_vendita_dal_data')?.clearValidators();
    }

    this.formSpettacolo.get('in_vendita_dal_data')?.updateValueAndValidity();
  }

  onPrezziSpettacolo(prezzi: PrezzoSpettacolo[]) {
    this.prezzi = [...prezzi];
  }
  
  onCastSpettacolo(cast: CastSpettacolo[]) {
    this.casts = [...cast];
  }  

  onImmaginiSpettacolo(immagini: {img_box: string, img_home: string, img_cover: string}) {
    this.immagini = immagini;
  }

  onSubmit() {

    let spettacolo = {
      spettacolo: this.formSpettacolo.get('spettacolo')?.value,
      compagnia: this.formSpettacolo.get('compagnia')?.value,
      descrizione: this.formSpettacolo.get('descrizione')?.value,
      dal: this.formSpettacolo.get('dal_al')?.value ? this.datePipe.transform(this.formSpettacolo.get('dal_al')?.value[0], 'yyyy-MM-dd') || null : null,
      al: this.formSpettacolo.get('dal_al')?.value ? this.datePipe.transform(this.formSpettacolo.get('dal_al')?.value[1], 'yyyy-MM-dd') || null : null,
      prenotabile_dal: this.formSpettacolo.get('prenotabile_dal')?.value ? this.datePipe.transform(this.formSpettacolo.get('prenotabile_dal')?.value, 'yyyy-MM-dd') || null : null,
      prenotabile_dal_orario: this.formSpettacolo.get('prenotabile_dal_orario')?.value ? this.datePipe.transform(this.formSpettacolo.get('prenotabile_dal_orario')?.value, 'HH:mm') || null : null,
      online: this.formSpettacolo.get('online')?.value ? (this.formSpettacolo.get('online')?.value.length > 0 ? true : false) : false,
      evidenzia: this.formSpettacolo.get('evidenzia')?.value ? (this.formSpettacolo.get('evidenzia')?.value.length > 0 ? true : false) : false,
      gratuito: this.formSpettacolo.get('gratuito')?.value ? (this.formSpettacolo.get('gratuito')?.value.length > 0 ? true : false) : false,
      in_vendita_dal: this.formSpettacolo.get('in_vendita_dal')?.value ? (this.formSpettacolo.get('in_vendita_dal')?.value.length > 0 ? true : false) : false,
      in_vendita_dal_data: this.formSpettacolo.get('in_vendita_dal_data')?.value ? this.datePipe.transform(this.formSpettacolo.get('in_vendita_dal_data')?.value, 'yyyy-MM-dd') || null : null,
      soon_in_vendita: this.formSpettacolo.get('soon_in_vendita')?.value ? (this.formSpettacolo.get('soon_in_vendita')?.value.length > 0 ? true : false) : false,
      sold_out: this.formSpettacolo.get('sold_out')?.value ? (this.formSpettacolo.get('sold_out')?.value.length > 0 ? true : false) : false,
      annullato: this.formSpettacolo.get('annullato')?.value ? (this.formSpettacolo.get('annullato')?.value.length > 0 ? true : false) : false,
      webshop: this.formSpettacolo.get('webshop')?.value ? (this.formSpettacolo.get('webshop')?.value.length > 0 ? true : false) : false,
      custom: this.formSpettacolo.get('custom')?.value ? (this.formSpettacolo.get('custom')?.value.length > 0 ? true : false) : false,
      link_webshop: this.formSpettacolo.get('link_webshop')?.value,
      link_custom: this.formSpettacolo.get('link_custom')?.value,
      descrizione_prezzi: this.formSpettacolo.get('descrizione_prezzi')?.value,
      img_box: this.immagini?.img_box || '',
      img_home: this.immagini?.img_home || '',
      img_cover: this.immagini?.img_cover || ''
    }

    let id_spettacolo = 0;

    this.loading = true;

    // Aggiungo la posizione in base a come sono nella tabella ai prezzi
    this.prezzi.map((prezzo, index) => prezzo.posizione = index);

    // Aggiungo la posizione in base a come sono nella tabella ai cast
    this.casts.map((cast, index) => cast.posizione = index);

    // Aggiungo lo spettacolo
    this.apiService.addSpettacolo(spettacolo).subscribe({
      next: (data) => id_spettacolo = data.id,
      error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
      complete: () => {

        // Aggiungo i prezzi salvati allo spettacolo appena caricato
        this.apiService.addPrezziSpettacolo({ prezzi: this.prezzi }, id_spettacolo).subscribe({
          error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
          complete: () => {

            // Aggiungo i cast salvati allo spettacolo appena caricato
            this.apiService.addCastSpettacolo({ casts: this.casts }, id_spettacolo).subscribe({
              error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
              complete: () => {
                this.loading = false;
                this.apiService.setSpettacoli();
                this.router.navigate(['/backoffice/spettacoli']);
                this.apiService.message('success', 'Successo', "Spettacolo aggiunto con successo!");
              }
            })
          }
        })
      }

    })

  }

}